// hsm = home sticky menu
export default
{
    name: 'app-hsm-link',

    props:
    {
        href: {type: String, default: '#'},
        spanClass: {type: String, default: ''},
        id: {type: Number},
        prevent: {type: Boolean, default: true}        
    },

    created()
    {
        this._isOver = -1
        this.eventHub.$on('overgame', this._overBtn)
        this.eventHub.$on('outgames', this._outBtn)
    },

    destroyed()
    {
        this.eventHub.$off('overgame', this._overBtn)
        this.eventHub.$off('outgames', this._outBtn)
    },

    methods:
    {
        _overBtn(id)
        {
            this._isOver = this.id === id ? Date.now() : -1
        },

        _outBtn()
        {
            this._isOver = -1
        },

        _onClick()
        {
            if (!this.prevent)
            {
                this.$root.changePage(this.href)
            }
            else if (this._isOver > 0 && Date.now() - this._isOver > 250)
            {
                this.$root.changePage(this.href)
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/scripts/components/app-hsm-link/script.js